import Model from '@/store/plugins/orm/Model'

export class ProductCategory extends Model {
    static get entity () {
        return 'product_categories'
    }

    static fields () {
        return {
            id: this.attr(null),
            name: this.attr(null),
            type: this.attr(null),
        }
    }
}

export default ProductCategory
